exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TripLaps-155c0b55{margin-bottom:30px}.TripLaps-155c0b55 .metrics-b380c180{display:flex;justify-content:flex-end}.TripLaps-155c0b55 .eleGain-30b8a212{flex:2 0 auto}.TripLaps-155c0b55 .distance-8d68a6d0{display:inline-block;flex:1 0 auto;text-align:right;margin-left:15px}\n", ""]);

// Exports
exports.locals = {
	"TripLaps": "TripLaps-155c0b55",
	"metrics": "metrics-b380c180",
	"eleGain": "eleGain-30b8a212",
	"distance": "distance-8d68a6d0"
};